<!-- Observer.vue -->
<template>
  <div class="observer"/>
</template>

<script>
export default {
  props: ['options' , 'customDisconnectFlag'],
  data: () => ({
    observer: null,
    customDisconnectFlagLocal : true
  }),
  mounted() {
    if(this.customDisconnectFlag !== undefined && this.customDisconnectFlag === false){
      this.customDisconnectFlagLocal = false;
    }

    const options = this.options || {rootMargin: '750px'};
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
        if(this.customDisconnectFlag)
          this.observer.disconnect();
      }
    }, options);
    this.observer.observe(this.$el);
  },
  destroyed() {
    this.observer.disconnect();
  },
};
</script>
